// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1bsMY","footer":"ReportModalFilter_footer__31gkK"};